<div class="ui-g">
    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
        <p-panel header="{{ 'arranger_details' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
            <app-arranger-details-form [isAdmin]="false" [userId]="0"></app-arranger-details-form>
        </p-panel>
    </div>    
</div>